import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      redirect: '/24sjcw'
    },
    {
      path: '/24sjcw',
      name: '24sjcw',
      component: () => import('@/views/pages/index'),
      meta: {
        pageTitle: '2024年四季“村晚”示范展示活动',
        keepAlive: true

      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/pages/news/index'),
      meta: {
        pageTitle: '活动快讯',
        keepAlive: true

      }
    },
        {
      path: '/myEyes/:type?',
      name: 'myEyes',
      component: () => import('@/views/pages/myEyes'),
      meta: {
        pageTitle: '我眼中的村晚',
        keepAlive: true

      }
    },
 
    
    {
      path: '/cultural/:type',
      name: 'cultural',
      component: () => import('@/views/pages/news/cultural'),
      meta: {
        pageTitle: '文旅专区',
        keepAlive: true

      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/pages/calendar'),
      meta: {
        pageTitle: '活动日历'
      }
    },

    {
      path: '/newsDetail/:id/:type',
      component: () => import('@/views/pages/news/detail'),
      name: 'newsDetail',
      meta: { pageTitle: '资讯详情', icon: 'app', noCache: true, }
    },
    {
      path: '/sjcwlist/:type',
      name: 'sjcwlist',
      component: () => import('@/views/pages/sjcwlist'),
      meta: {
        pageTitle: '四季村晚',
        keepAlive: true

      }
    },
    {
      path: '/sjcwDetail/:index',
      name: 'sjcwDetail',
      component: () => import('@/views/pages/pic_detail/sjcw'),
      meta: {
        pageTitle: '四季村晚详情',
      }
    },
    {
      path: '/picshow/:type',
      name: 'picshow',
      component: () => import('@/views/pages/picshow'),
      meta: {
        pageTitle: '带你看村晚',
        keepAlive: true
      }
    },

    {
      path: '/dnkcwDetail/:code/:teamCode',
      name: 'dnkcwDetail',
      component: () => import('@/views/pages/pic_detail/dnkcw'),
      meta: {
        pageTitle: '带你看村晚',
      }
    },
    {
      path: '/pic_detail/:ocCode/:sortIndex/:teamCode/:ocName?/:searchSort',
      name: 'pic_detail',
      component: () => import('@/views/pages/pic_detail/index'),
      meta: {
        pageTitle: '视频详情'
      }
    },
    {
      path: '/img_detail/:ocCode/:sortIndex/:teamCode/:ocName?/:searchSort',
      name: 'img_detail',
      component: () =>
        import('@/views/pages/img_detail/index'),
      meta: {
        pageTitle: '图片详情'
      }
    },
    {
      path: '/monselect/:type',
      name: 'monselect',
      component: () => import('@/views/pages/monselect'),
      meta: {
        pageTitle: '最爱节目',
        keepAlive: true
      }
    },
    {
      path: '/zajmDetail/:ocCode/:type',
      name: 'zajmDetail',
      component: () => import('@/views/pages/pic_detail/zajm'),
      meta: {
        pageTitle: '最爱节目详情',
        // keepAlive: true
      }
    },
 
    {
      path: '/villageDetail/:ocCode',
      name: 'villageDetail',
      component: () => import('@/views/pages/pic_detail/xcwh'),
      meta: {
        pageTitle: '我眼中的村晚详情',
        // keepAlive: true
      }
    },
    {
      path: '/resultview',
      name: 'resultview',
      component: () => import('@/views/pages/resultview'),
      meta: {
        pageTitle: '结果公示'
      }
    },
    {
      path: '/worksubmit',
      name: 'worksubmit',
      component: () => import('@/views/pages/worksubmit/index'),
      meta: {
        pageTitle: '信息填写'
      }
    },


    {
      path: '/login',
      component: () => import('@/views/login/login'),
      name: 'login',
      meta: { pageTitle: '登录页', icon: 'app', noCache: true }
    },
    // -------------------------------后台--资讯-----------------------------
    {
      path: '/newsList',
      component: () => import('@/views/admin/newsList/news'),
      name: 'newsList',
      meta: { pageTitle: '活动快讯', icon: 'app', noCache: true }
    },
    {
      path: '/addNews',
      component: () => import('@/views/admin/newsList/add'),
      name: 'addNews',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/newsList' }
    },
    {
      path: '/editNews/:id',
      component: () => import('@/views/admin/newsList/edit'),
      name: 'editNews',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/newsList' }
    },
    {
      path: '/culturallist',
      component: () => import('@/views/admin/villList/list'),
      name: 'culturallist',
      meta: { pageTitle: '示范点风采', icon: 'app', noCache: true }
    },
    {
      path: '/addCultural',
      component: () => import('@/views/admin/villList/add'),
      name: 'addCultural',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/culturallist' }
    },
    {
      path: '/editCultural/:id',
      component: () => import('@/views/admin/villList/edit'),
      name: 'editCultural',
      meta: { pageTitle: '新增', icon: 'app', noCache: true, activeMenu: '/culturallist' }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js